module.exports = __webpack_public_path__ + "static/media/VCG41N1148195784.f363dc85.jpg";